import { render, staticRenderFns } from "./bottom-navigation.vue?vue&type=template&id=7428761e&scoped=true"
import script from "./bottom-navigation.vue?vue&type=script&lang=js"
export * from "./bottom-navigation.vue?vue&type=script&lang=js"
import style0 from "./bottom-navigation.vue?vue&type=style&index=0&id=7428761e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7428761e",
  null
  
)

export default component.exports